import React from "react";
import {Toolbar} from "react-data-grid-addons";

/*
  Why does this component exist?

  This component exists because the Toolbar component within the React-Data-Grid-Addons library
  has substandard functionality and does not possess a way to keep filters open on page load!

  This component takes the place of the <Toolbar/> component in React-Data-Grid.

  The enableFilter prop passed down from the Customers/Vendors page is what renders the
  Filter Rows button. The onToggleFilter within the CDM sets the filter to be open
  on render.
*/

export default class FilterToolbar extends React.Component {
  componentDidMount() {
    this.props.onToggleFilter();
  }

  render() {
    return <Toolbar {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/FilterToolbar.jsx